export const OTP_COMPLETE_EVENT = "otpcomplete";

export class OtpCompleteEvent extends Event {
  constructor() {
    super(OTP_COMPLETE_EVENT);
  }
}
